import { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import MDButtonRoot from "ui/MDButton/MDButtonRoot";
import { useMaterialUIController } from "context";
import CircularProgress from "@mui/material/CircularProgress"; // Import CircularProgress

const MDButton = forwardRef(
  ({ color, variant, size, circular, iconOnly, children, loading, ...rest }, ref) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
      <MDButtonRoot
        {...rest}
        ref={ref}
        color="primary"
        variant={variant === "gradient" ? "contained" : variant}
        size={size}
        ownerState={{ color, variant, size, circular, iconOnly, darkMode }}
        disabled={loading} // Disable button while loading
      >
        {children} {loading && (
          <CircularProgress style={{ marginLeft: "5px" }} size={24} color="inherit" /> // Use MUI CircularProgress
        )}
        
      </MDButtonRoot>
    );
  }
);

// Setting default values for the props of MDButton
MDButton.defaultProps = {
  size: "medium",
  variant: "contained",
  color: "white",
  circular: false,
  iconOnly: false,
  loading: false, // Default loading state
};

// Typechecking props for the MDButton
MDButton.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["text", "contained", "outlined", "gradient"]),
  color: PropTypes.oneOf([
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  circular: PropTypes.bool,
  iconOnly: PropTypes.bool,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool, // Prop for loading state
};

export default MDButton;
